import { render, staticRenderFns } from "./GiftPayPage.vue?vue&type=template&id=1f2b3ac2&scoped=true"
import script from "./GiftPayPage.vue?vue&type=script&lang=js"
export * from "./GiftPayPage.vue?vue&type=script&lang=js"
import style0 from "./GiftPayPage.vue?vue&type=style&index=0&id=1f2b3ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b3ac2",
  null
  
)

export default component.exports